<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="form.id ? $t('labels.edit_user', {req: form.name}) : $t('labels.create_user')"
         @onClose="hide"
  >
    <form class="requisites">

      <div class="requisites__container">

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.name") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="name" form="userForm">
              <input v-model="form.name" :class="parentProps.class" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="requisites__block">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.email") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="email" form="userForm">
              <input v-model="form.email" :readonly="!!form.id" :class="parentProps.class" type="text" class="form-control " id="email">
            </FormInputWrapper>
          </div>
        </div>


        <div class="requisites__block requisites__block--switcher">
          <div class="requisites__label text-capitalize-first">{{ $t('labels.is_blocked') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.isBlocked">
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="requisites__block requisites__block--switcher" v-if="!form.id">
          <div class="requisites__label text-capitalize-first">{{ $t('labels.create_invite') }}</div>
          <div class="requisites__content requisites__content__switch">
            <label class="switch">
              <input type="checkbox" v-model="form.createInvite">
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="requisites__block" v-if="form.id || form.createInvite === false">
          <div class="requisites__label requisites__label--start text-capitalize-first">
            {{ $t("labels.password") }}
          </div>
          <div class="requisites__content">
            <FormInputWrapper v-slot="parentProps" field="password" form="userForm">
              <input v-model="form.password"  :class="parentProps.class" type="text" class="form-control " id="password">
            </FormInputWrapper>
          </div>
        </div>
      </div>

      <div class="requisites__controls">
        <button class="btn" type="button" @click.prevent="hide">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="save" class="btn btn--accept">
          <span class="text-capitalize-first">{{ $t('button.save') }}</span>
        </LoaderButton>
      </div>
    </form>
  </Popup>
  <InviteLinkConfirmPopup ref="inviteLinkConfirmPopup"></InviteLinkConfirmPopup>
</template>
<script lang="ts">
import {computed, defineComponent, PropType, ref, watch} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useNotification} from "@kyvg/vue3-notification";
import {useStore} from "vuex";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import Multiselect from "vue-multiselect";
import TraderOperatorFormDTO, { defaultCreateForm } from '@/models/form/TraderOperatorFormDTO';
import UserUpdateRequestDTO from "@/models/request/UserUpdateRequestDTO";
import UserCreateRequestDTO from "@/models/request/UserCreateRequestDTO";
import TraderOperatorDTO from "@/models/TraderOperatorDTO";
import InviteLinkConfirmPopup from "@/apps/public/components/InviteLinkConfirmPopup.vue";


export default defineComponent({
  emits: ['updated'],
  methods: {$t},
  components: {
    InviteLinkConfirmPopup,
    FormInputWrapper,
    LoaderButton,
    CopyButton,
    Popup,
    Multiselect
  },
  setup(props, {emit}) {
    const notification = useNotification()
    const store = useStore()
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const inviteLinkConfirmPopup = ref<InstanceType<typeof InviteLinkConfirmPopup> | null>(null)

    const state = reactive({
      form: {} as TraderOperatorFormDTO,
    });

    const show = (dto: TraderOperatorDTO) => {
      helper.clearErrors('userForm')

      if (dto.id) {
        state.form = {
          ...defaultCreateForm,
          ...dto
        } as TraderOperatorFormDTO
      } else {
        state.form = {...defaultCreateForm, password: helper.generatePassword()} as TraderOperatorFormDTO
      }

      popup.value?.show()
    }


    const save = async () => {
      const form = state.form
      let promise;
      if (form.id) {
        promise = api.call.traderOperators.update(form.id, {
          ...form,
          password: form.password ? form.password : null,
        } as UserUpdateRequestDTO)
          .then((resp) => {
            notification.notify({title: helper.trans('users.notice.updated')});
          })
      } else {
        promise = api.call.traderOperators.create({
          ...form,
          password: form.createInvite ? null : (form.password ? form.password : null),
          createInvite: form.createInvite,
        } as UserCreateRequestDTO)
          .then((user) => {
            if (user.inviteToken) {
              const url = store.getters['getInviteLink'](user);
              inviteLinkConfirmPopup.value?.show(url);
            }
            notification.notify({title: helper.trans('users.notice.created')});
          })
      }

      try {
        const resp = await promise;
        emit('updated')
        hide()
      } catch (e) {
        helper.handleErrors('userForm', e)
        console.log(e);
      }
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      popup,
      store,
      show,
      hide,
      helper,
      save,
      inviteLinkConfirmPopup,
    }
  },
  async beforeMount() {
  }
})
</script>
